import React, { useState } from 'react';

const MemberCard = ({ 
  name, 
  memberId, 
  imageUrl, 
  batchYear, 
  currentWork, 
  location, 
  socialMedia 
}) => {
  const [isHovered, setIsHovered] = useState(false);

  // Use mock image if no image URL is provided
  const displayImage = imageUrl || 'assets/silver-avatar.webp';

  return (
    <div 
      data-hover={isHovered ? "on" : "off"}
      className="relative flex-1 min-w-0 bg-white overflow-hidden transition-all duration-300 ease-in-out"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Image Container */}
      <div className={`w-full overflow-hidden rounded-[20px] border-2 border-[#c0c0c0] relative shadow-[0_0_15px_rgba(136,140,143,0.4),inset_0_0_20px_rgba(255,255,255,0.2)]x drop-shadow-lg bg-gradient-to-r from-slate-200 via-white to-gray-300 transition-all duration-500 ease-in-out ${
        isHovered ? 'aspect-[1/1]' : 'aspect-[3/4]'
      }`}>
        <img 
          alt={name} 
          className="w-full h-full object-cover object-center rounded-[16px]" 
          src={displayImage}
        />
      </div>
      
      {/* Info Container */}
      <div className="w-full bg-white px-4 py-4 flex flex-col justify-start items-start gap-1">
        {/* Name */}
        <div className="text-black text-sm sm:text-base md:text-lg lg:text-[22px] font-bold font-['Montserrat'] leading-tight">
          {name}
        </div>
        
        {/* Silver Member ID */}
        <div className="flex gap-2 items-center text-black text-xs sm:text-sm md:text-base tracking-[0.16px] leading-none">
          <div className="font-normal font-['Montserrat']">
            Silver Member:
          </div>
          <div className="font-bold font-['Montserrat']">
            {memberId}
          </div>
        </div>

        {/* Additional Details - Shown on Hover */}
        <div 
          className={`w-full flex flex-col gap-1 transition-all duration-500 ease-in-out ${
            isHovered 
              ? 'max-h-[500px] opacity-100 mt-' 
              : 'max-h-0 opacity-0 overflow-hidden'
          }`}
        >
          {batchYear && (
            <div className="flex gap-2 items-baseline text-black text-xs sm:text-sm md:text-base tracking-[0.16px] leading-none">
              <div className="font-normal font-['Montserrat']">
                Batch Year:
              </div>
              <div className="font-bold font-['Montserrat']">
                {batchYear}
              </div>
            </div>
          )}

          {currentWork && (
            <div className="flex gap-2 items-baseline text-black text-xs sm:text-sm md:text-base tracking-[0.16px] leading-none">
              <div className="font-normal font-['Montserrat']">
                Current Work:
              </div>
              <div className="font-bold font-['Montserrat']">
                {currentWork}
              </div>
            </div>
          )}

          {location && (
            <div className="flex gap-2 items-baseline text-black text-xs sm:text-sm md:text-base tracking-[0.16px] leading-none">
              <div className="font-normal font-['Montserrat']">
                Location:
              </div>
              <div className="font-bold font-['Montserrat']">
                {location}
              </div>
            </div>
          )}

          {/* Social Media Icons */}
          {socialMedia && (
            <div className="flex gap-3 items-center justify-start mt-3">
              {socialMedia.facebook && (
                <a 
                  href={socialMedia.facebook} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-8 h-8 rounded-full bg-gray-100 hover:bg-Color-Brand flex items-center justify-center transition-colors duration-300 group"
                >
                  <svg className="w-4 h-4 text-gray-600 group-hover:text-white transition-colors duration-300" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M18.3333 10.0001C18.3333 5.40508 14.595 1.66675 9.99999 1.66675C5.40499 1.66675 1.66666 5.40508 1.66666 10.0001C1.66666 14.0301 4.53833 17.3859 8.33332 18.1667V12.5001H6.66666V10.0001H8.33332V8.33341C8.33332 6.66675 9.66666 5.33341 11.3333 5.33341H13V7.83341H11.3333C10.875 7.83341 10.5 8.20841 10.5 8.66675V10.0001H13V12.5001H10.5V18.2876C14.6583 17.8726 17.9167 14.3167 18.3333 10.0001Z" />
                  </svg>
                </a>
              )}
              {socialMedia.linkedin && (
                <a 
                  href={socialMedia.linkedin} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-8 h-8 rounded-full bg-gray-100 hover:bg-Color-Brand flex items-center justify-center transition-colors duration-300 group"
                >
                  <svg className="w-[18px] h-[18px] text-gray-600 group-hover:text-white transition-colors duration-300" viewBox="0 0 18 18" fill="currentColor">
                    <path d="M4.14998 6.75H0.974976V18H4.14998V6.75ZM2.56248 5.43C3.56248 5.43 4.37248 4.605 4.37248 3.6C4.37248 2.595 3.56248 1.785 2.56248 1.785C1.54498 1.785 0.719971 2.595 0.719971 3.6C0.719971 4.605 1.54498 5.43 2.56248 5.43ZM17.28 18H17.2875V11.625C17.2875 8.8275 16.665 6.6225 13.3875 6.6225C11.8125 6.6225 10.74 7.5225 10.2975 8.3775H10.2525V6.75H7.20748V18H10.3825V12.195C10.3825 10.86 10.6275 9.5775 12.2625 9.5775C13.875 9.5775 13.8975 11.0925 13.8975 12.2775V17.985H17.07L17.28 18Z" />
                  </svg>
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MemberCard;
